export type DayStatus = 'sin_asignar' | 'esperando' | 'ingresado' | 'completo' | 'falta';

export interface DayStatusRow {
  hasApprovedAssignment: boolean;
  hasEntry: boolean;
  hasExit: boolean;
  /** Fecha de la posición, YYYY-MM-DD (hora Lima). */
  date: string;
  /** Hora de fin de la posición, HH:mm o HH:mm:ss. */
  endTime: string;
  /** Momento actual en Lima como 'YYYY-MM-DDTHH:mm:ss' (lo calcula el llamador con date-fns-tz). */
  nowLima: string;
}

const normalizeTime = (t: string): string => (t.length === 5 ? `${t}:00` : t);

/**
 * Estado operativo de una posición del día. La comparación es lexicográfica sobre
 * cadenas locales de Lima ya normalizadas, así que la función es pura y sin zona horaria.
 */
export function dayStatus(row: DayStatusRow): DayStatus {
  if (!row.hasApprovedAssignment) return 'sin_asignar';
  if (row.hasEntry && row.hasExit) return 'completo';
  if (row.hasEntry || row.hasExit) return 'ingresado';
  const endsAt = `${row.date}T${normalizeTime(row.endTime)}`;
  return row.nowLima > endsAt ? 'falta' : 'esperando';
}
